import styled from 'styled-components';

import { BaseStyle, TabBar } from '@nhl/nhl-breakaway-ui';

const BY_GAME_TYPE = 'game';

export const TimeSelectTabBar = styled(TabBar)`
    border-bottom: none;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.large} {
        max-width: min-content;
    }

    .tab-bar {
        border: 1px solid ${({ theme }) => theme.Surface.border};
        border-radius: 8px;
        gap: unset;
        height: 32px;
    }

    .tab-indicator {
        display: none;
    }

    .tab-item {
        ${BaseStyle.Mixins.fontStyles.ui['14b']}
        border: none;
        color: ${({ theme }) => theme.Text.primary};
        flex: auto;
        padding: 0 20px;
        white-space: nowrap;
        width: min-content;
    }

    .selected {
        background-color: ${({ theme }) => theme.Text.primary};
        color: ${({ theme }) => theme.Surface.primary};
    }

    .tab-item:first-child {
        border-right: 1px solid
            ${({ theme, selectedTab }) => (selectedTab.key === BY_GAME_TYPE ? 'transparent' : theme.Surface.border)};
    }

    .tab-item:last-child {
        border-left: 1px solid
            ${({ theme, selectedTab }) => (selectedTab.key === BY_GAME_TYPE ? 'transparent' : theme.Surface.border)};
    }

    .tab-item:first-child.selected {
        & {
            border-color: transparent;
        }
    }

    .tab-item:last-child.selected {
        & {
            border-color: transparent;
        }
    }
`;
